import React from 'react'
import Layout from 'components/Layout'
import { wwwActivity } from 'constants/img'

export default function ActivityPage() {
  return (
    <Layout
      title=""
      keywords="NiuLink, PCDN, 边缘计算平台"
      description="NiuLink 简单高效的雾计算平台"
      withCustomContent
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={wwwActivity} style={{ maxWidth: '100%' }} />
      </div>
    </Layout>
  )
}
